// -----------------------------------------------------------------------
// Import React and other resources
// -----------------------------------------------------------------------
import React from "react";
import {Pane} from "evergreen-ui";
import Chart from "react-apexcharts"

// -----------------------------------------------------------------------
// DayGraph Component
// -----------------------------------------------------------------------
class DayGraph extends React.Component {

    options = {
        chart: {
            id: "basic-bar"
        },
        xaxis: {
            categories: []
        },
        yaxis: {
            tickAmount: 10,
            min: 0,
            max: 100,
            labels: {
                formatter: (value) => {
                    return value + "%"
                }
            }
        },
        dataLabels: {
            enabled: false,
        },
        tooltip: {
            enabled: true,
            y: {
                formatter: (value) => {
                    return value + "%"
                }
            }
        }
    };

    getFormattedUtilisation = (utilisation) => {
        this.options.xaxis.categories = [];
        const series = [{
            name: "utilisation",
            data: []
        }];
        Object.keys(utilisation).forEach(slot => {
            this.options.xaxis.categories.push(slot.slice(0,5));
            series[0].data.push(utilisation[slot].percentage)
        });
        return series
    };

    render() {
        const {utilisation, graphType} = this.props;
        const series = this.getFormattedUtilisation(utilisation);
        return (
            graphType === 1 ?
                <Pane padding={16} flex="1">
                    <Chart
                        options={this.options}
                        series={series}
                        type="bar"
                        width="1000"
                        height="400"
                    />
                </Pane> : <div/>
        )
    }
}

// -----------------------------------------------------------------------
// Export
// -----------------------------------------------------------------------
export default DayGraph;